import { ListingCardImage } from './ListingCardImage';

export const HUB_FEATURED_BANNER_ASPECT =
  'aspect-[4/3] sm:aspect-[16/9] md:aspect-[2/1]';

const bannerContainerClassName = `relative w-full max-w-full overflow-hidden rounded-2xl ${HUB_FEATURED_BANNER_ASPECT}`;

const bannerImageClassName =
  'absolute inset-0 h-full w-full max-w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105';

const bannerFallbackClassName =
  'absolute inset-0 flex h-full w-full flex-col items-center justify-center gap-3 bg-gradient-to-br from-[#E8F7F5] to-[#D4EEF0] px-5 py-6 text-center transition-transform duration-500 ease-out group-hover:scale-[1.02]';

export function HubFeaturedBannerImage({
  mediaPath,
  title,
  postType,
  alt = '',
}) {
  return (
    <div className={bannerContainerClassName}>
      <ListingCardImage
        mediaPath={mediaPath}
        title={title}
        postType={postType}
        alt={alt}
        containerClassName={bannerFallbackClassName}
        imageClassName={bannerImageClassName}
        iconClassName="h-12 w-12 text-[#0099B0]/70 sm:h-14 sm:w-14"
        showFallbackLabel={false}
        showFallbackTitle={false}
        showFallbackMessage={false}
      />
    </div>
  );
}
